import { parseNumberStrict, removeNulls, safeParse, safeParseNullDefault } from 'shouldve-been-js';
import ObservationCustomComponentModel from './ObservationCustomComponentModelModel';

class ObservationModel {

    private _observationId: string;
    private _caption: string;
    private _description: string;
    private _status: string;
    private _ruleSetsActive: boolean;
    private _ruleSetIds: string[];
    private _priorityActive: boolean;
    private _priorityCaption: string;
    private _priorityOptions: string[];
    private _priorityItemEnableMask: boolean[];
    private _priorityVisualOrdering: number[];
    private _inspectorCommentActive: boolean;
    private _inspectorCommentSortNumber: number;
    private _inspectorCommentCaption: string;
    private _generalCommentActive: boolean;
    private _generalCommentSortNumber: number;
    private _generalCommentCaption: string;
    private _rootCauseActive: boolean;
    private _rootCauseSortNumber: number;
    private _rootCauseCaption: string;
    private _correctiveActionActive: boolean;
    private _correctiveActionSortNumber: number;
    private _correctiveActionCaption: string;
    private _preventiveActionActive: boolean;
    private _preventiveActionSortNumber: number;
    private _preventiveActionCaption: string;
    private _additionalCommentActive: boolean;
    private _additionalCommentSortNumber: number;
    private _additionalCommentCaption: string;
    private _customComponents: ObservationCustomComponentModel[];

    public constructor(observationId: string, caption: string, description: string, status: string, ruleSetsActive: boolean, ruleSetIds: string[], priorityActive: boolean, priorityCaption: string, priorityOptions: string[], priorityItemEnableMask: boolean[], priorityVisualOrdering: number[], inspectorCommentActive: boolean, inspectorCommentSortNumber: number, inspectorCommentCaption: string, generalCommentActive: boolean, generalCommentSortNumber: number, generalCommentCaption: string, rootCauseActive: boolean, rootCauseSortNumber: number, rootCauseCaption: string, correctiveActionActive: boolean, correctiveActionSortNumber: number, correctiveActionCaption: string, preventiveActionActive: boolean, preventiveActionSortNumber: number, preventiveActionCaption: string, additionalCommentActive: boolean, additionalCommentSortNumber: number, additionalCommentCaption: string, customComponents: ObservationCustomComponentModel[]) {

        this._observationId = observationId;
        this._caption = caption;
        this._description = description;
        this._status = status;
        this._ruleSetsActive = ruleSetsActive;
        this._ruleSetIds = ruleSetIds;
        this._priorityActive = priorityActive;
        this._priorityCaption = priorityCaption;
        this._priorityOptions = priorityOptions;
        this._priorityItemEnableMask = priorityItemEnableMask;
        this._priorityVisualOrdering = priorityVisualOrdering;
        this._inspectorCommentActive = inspectorCommentActive;
        this._inspectorCommentSortNumber = inspectorCommentSortNumber;
        this._inspectorCommentCaption = inspectorCommentCaption;
        this._generalCommentActive = generalCommentActive;
        this._generalCommentSortNumber = generalCommentSortNumber;
        this._generalCommentCaption = generalCommentCaption;
        this._rootCauseActive = rootCauseActive;
        this._rootCauseSortNumber = rootCauseSortNumber;
        this._rootCauseCaption = rootCauseCaption;
        this._correctiveActionActive = correctiveActionActive;
        this._correctiveActionSortNumber = correctiveActionSortNumber;
        this._correctiveActionCaption = correctiveActionCaption;
        this._preventiveActionActive = preventiveActionActive;
        this._preventiveActionSortNumber = preventiveActionSortNumber;
        this._preventiveActionCaption = preventiveActionCaption;
        this._additionalCommentActive = additionalCommentActive;
        this._additionalCommentSortNumber = additionalCommentSortNumber;
        this._additionalCommentCaption = additionalCommentCaption;
        this._customComponents = customComponents;
    }

    public get observationId(): string {
        return this._observationId;
    }

    public set observationId(value: string) {
        this._observationId = value;
    }

    public get caption(): string {
        return this._caption;
    }

    public set caption(value: string) {
        this._caption = value;
    }

    public get description(): string {
        return this._description;
    }

    public set description(value: string) {
        this._description = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    public get ruleSetsActive(): boolean {
        return this._ruleSetsActive;
    }

    public set ruleSetsActive(value: boolean) {
        this._ruleSetsActive = value;
    }

    public get ruleSetIds(): string[] {
        return this._ruleSetIds;
    }

    public set ruleSetIds(value: string[]) {
        this._ruleSetIds = value;
    }

    public get priorityActive(): boolean {
        return this._priorityActive;
    }

    public set priorityActive(value: boolean) {
        this._priorityActive = value;
    }

    public get priorityCaption(): string {
        return this._priorityCaption;
    }

    public set priorityCaption(value: string) {
        this._priorityCaption = value;
    }

    public get priorityOptions(): string[] {
        return this._priorityOptions;
    }

    public set priorityOptions(value: string[]) {
        this._priorityOptions = value;
    }

    public get priorityItemEnableMask(): boolean[] {
        return this._priorityItemEnableMask;
    }

    public set priorityItemEnableMask(value: boolean[]) {
        this._priorityItemEnableMask = value;
    }

    public get priorityVisualOrdering(): number[] {
        return this._priorityVisualOrdering;
    }

    public set priorityVisualOrdering(value: number[]) {
        this._priorityVisualOrdering = value;
    }

    public get inspectorCommentActive(): boolean {
        return this._inspectorCommentActive;
    }

    public set inspectorCommentActive(value: boolean) {
        this._inspectorCommentActive = value;
    }

    public get inspectorCommentSortNumber(): number {
        return this._inspectorCommentSortNumber;
    }

    public set inspectorCommentSortNumber(value: number) {
        this._inspectorCommentSortNumber = value;
    }

    public get inspectorCommentCaption(): string {
        return this._inspectorCommentCaption;
    }

    public set inspectorCommentCaption(value: string) {
        this._inspectorCommentCaption = value;
    }

    public get generalCommentActive(): boolean {
        return this._generalCommentActive;
    }

    public set generalCommentActive(value: boolean) {
        this._generalCommentActive = value;
    }

    public get generalCommentSortNumber(): number {
        return this._generalCommentSortNumber;
    }

    public set generalCommentSortNumber(value: number) {
        this._generalCommentSortNumber = value;
    }

    public get generalCommentCaption(): string {
        return this._generalCommentCaption;
    }

    public set generalCommentCaption(value: string) {
        this._generalCommentCaption = value;
    }

    public get rootCauseActive(): boolean {
        return this._rootCauseActive;
    }

    public set rootCauseActive(value: boolean) {
        this._rootCauseActive = value;
    }

    public get rootCauseSortNumber(): number {
        return this._rootCauseSortNumber;
    }

    public set rootCauseSortNumber(value: number) {
        this._rootCauseSortNumber = value;
    }

    public get rootCauseCaption(): string {
        return this._rootCauseCaption;
    }

    public set rootCauseCaption(value: string) {
        this._rootCauseCaption = value;
    }

    public get correctiveActionActive(): boolean {
        return this._correctiveActionActive;
    }

    public set correctiveActionActive(value: boolean) {
        this._correctiveActionActive = value;
    }

    public get correctiveActionSortNumber(): number {
        return this._correctiveActionSortNumber;
    }

    public set correctiveActionSortNumber(value: number) {
        this._correctiveActionSortNumber = value;
    }

    public get correctiveActionCaption(): string {
        return this._correctiveActionCaption;
    }

    public set correctiveActionCaption(value: string) {
        this._correctiveActionCaption = value;
    }

    public get preventiveActionActive(): boolean {
        return this._preventiveActionActive;
    }

    public set preventiveActionActive(value: boolean) {
        this._preventiveActionActive = value;
    }

    public get preventiveActionSortNumber(): number {
        return this._preventiveActionSortNumber;
    }

    public set preventiveActionSortNumber(value: number) {
        this._preventiveActionSortNumber = value;
    }

    public get preventiveActionCaption(): string {
        return this._preventiveActionCaption;
    }

    public set preventiveActionCaption(value: string) {
        this._preventiveActionCaption = value;
    }

    public get additionalCommentActive(): boolean {
        return this._additionalCommentActive;
    }

    public set additionalCommentActive(value: boolean) {
        this._additionalCommentActive = value;
    }

    public get additionalCommentSortNumber(): number {
        return this._additionalCommentSortNumber;
    }

    public set additionalCommentSortNumber(value: number) {
        this._additionalCommentSortNumber = value;
    }

    public get additionalCommentCaption(): string {
        return this._additionalCommentCaption;
    }

    public set additionalCommentCaption(value: string) {
        this._additionalCommentCaption = value;
    }

    public get customComponents(): ObservationCustomComponentModel[] {
        return this._customComponents;
    }

    public set customComponents(value: ObservationCustomComponentModel[]) {
        this._customComponents = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(key: string, json: any): ObservationModel | null {

        const observationId: string | null = key;
        const caption: string = safeParse<string>(json?.caption, '');
        const description: string = safeParse<string>(json?.description, '');
        const status: string | null = safeParseNullDefault<string>(json?.status, '');
        const ruleSetsActive: boolean = safeParse<boolean>(json?.ruleSetsActive, true);
        const ruleSetIdsString: string = safeParse<string>(json?.ruleSetIds, '');

        const ruleSetIds: string[] = ruleSetIdsString === '' ? [] : ruleSetIdsString.split(',');

        const priorityActive: boolean = (json?.priorityComponent ?? null) !== null;
        const priorityCaption: string = safeParse<string>(json?.priorityComponent?.caption, '');
        const priorityOptionsString: string = safeParse<string>(json?.priorityComponent?.options, '');
        const priorityItemEnableMaskString: string = safeParse<string>(json?.priorityComponent?.itemEnableMask, '');
        const priorityVisualOrderingString: string = safeParse<string>(json?.priorityComponent?.visualOrdering, '');
        const priorityOptions: string[] = priorityOptionsString.split(';');
        const priorityItemEnableMask: boolean[] = priorityItemEnableMaskString === '' ? [] : priorityItemEnableMaskString.split(';').map((value: string) => value === '1');
        const priorityVisualOrdering: number[] = removeNulls(priorityVisualOrderingString.split(';').map((element: string) => parseNumberStrict(element)));

        if (priorityActive && priorityOptions.length !== priorityVisualOrdering.length) {
            return null;
        }

        const inspectorCommentActive: boolean = (json?.inspectorCommentComponent ?? null) !== null;
        const inspectorCommentSortNumber: number = safeParse<number>(json?.inspectorCommentComponent?.sortNumber, 0);
        const inspectorCommentCaption: string = safeParse<string>(json?.inspectorCommentComponent?.caption, '');

        const generalCommentActive: boolean = (json?.generalCommentComponent ?? null) !== null;
        const generalCommentSortNumber: number = safeParse<number>(json?.generalCommentComponent?.sortNumber, 0);
        const generalCommentCaption: string = safeParse<string>(json?.generalCommentComponent?.caption, '');

        const rootCauseActive: boolean = (json?.rootCauseComponent ?? null) !== null;
        const rootCauseSortNumber: number = safeParse<number>(json?.rootCauseComponent?.sortNumber, 0);
        const rootCauseCaption: string = safeParse<string>(json?.rootCauseComponent?.caption, '');

        const correctiveActionActive: boolean = (json?.correctiveActionComponent ?? null) !== null;
        const correctiveActionSortNumber: number = safeParse<number>(json?.correctiveActionComponent?.sortNumber, 0);
        const correctiveActionCaption: string = safeParse<string>(json?.correctiveActionComponent?.caption, '');

        const preventiveActionActive: boolean = (json?.preventiveActionComponent ?? null) !== null;
        const preventiveActionSortNumber: number = safeParse<number>(json?.preventiveActionComponent?.sortNumber, 0);
        const preventiveActionCaption: string = safeParse<string>(json?.preventiveActionComponent?.caption, '');

        const additionalCommentActive: boolean = (json?.additionalCommentComponent ?? null) !== null;
        const additionalCommentSortNumber: number = safeParse<number>(json?.additionalCommentComponent?.sortNumber, 0);
        const additionalCommentCaption: string = safeParse<string>(json?.additionalCommentComponent?.caption, '');

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call
        const customComponents: (ObservationCustomComponentModel | null)[] = json?.customComponents?.map((customComponent: any) => ObservationCustomComponentModel.fromJson(customComponent)) ?? [];
        
        if (observationId === null || status === null || observationId === '') {
            return null;
        }

        return new ObservationModel(observationId, caption, description, status, ruleSetsActive, ruleSetIds, priorityActive, priorityCaption, priorityOptions, priorityItemEnableMask, priorityVisualOrdering, inspectorCommentActive, inspectorCommentSortNumber, inspectorCommentCaption, generalCommentActive, generalCommentSortNumber, generalCommentCaption, rootCauseActive, rootCauseSortNumber, rootCauseCaption, correctiveActionActive, correctiveActionSortNumber, correctiveActionCaption, preventiveActionActive, preventiveActionSortNumber, preventiveActionCaption, additionalCommentActive, additionalCommentSortNumber, additionalCommentCaption, removeNulls(customComponents));
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): ObservationModel | null {

        const observationId: string | null = safeParseNullDefault<string>(object?._observationId, '');
        const caption: string = safeParse<string>(object?._caption, '');
        const description: string = safeParse<string>(object?._description, '');
        const status: string | null = safeParseNullDefault<string>(object?._status, '');

        const ruleSetsActive: boolean = safeParse<boolean>(object?._ruleSetsActive, true);
        
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const ruleSetIds: string[] = object?._ruleSetIds;

        if (!Array.isArray(ruleSetIds)) {
            return null;
        }

        if (!ruleSetIds.every((ruleSetId: string) => typeof ruleSetId === 'string')) {
            return null;
        }

        const priorityActive: boolean = safeParse<boolean>(object?._priorityActive, false);
        const priorityCaption: string = safeParse<string>(object?._priorityCaption, '');
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const priorityOptions: string[] = object?._priorityOptions;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const priorityItemEnableMask: boolean[] = object?._priorityItemEnableMask;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const priorityVisualOrdering: number[] = object?._priorityVisualOrdering;

        if (priorityActive) {
            
            if (!Array.isArray(priorityOptions)) {
                return null;
            }

            if (!priorityOptions.every((option: string) => typeof option === 'string')) {
                return null;
            }

            if (!Array.isArray(priorityItemEnableMask)) {
                return null;
            }

            if (!priorityItemEnableMask.every((value: boolean) => typeof value === 'boolean')) {
                return null;
            }

            if (!Array.isArray(priorityVisualOrdering)) {
                return null;
            }

            if (!priorityVisualOrdering.every((orderingElement: number) => typeof orderingElement === 'number')) {
                return null;
            }

            if (priorityOptions.length !== priorityVisualOrdering.length) {
                return null;
            }
        }

        const inspectorCommentActive: boolean = safeParse<boolean>(object?._inspectorCommentActive, false);
        const inspectorCommentSortNumber: number = safeParse<number>(object?._inspectorCommentSortNumber, 0);
        const inspectorCommentCaption: string = safeParse<string>(object?._inspectorCommentCaption, '');

        const generalCommentActive: boolean = safeParse<boolean>(object?._generalCommentActive, false);
        const generalCommentSortNumber: number = safeParse<number>(object?._generalCommentSortNumber, 0);
        const generalCommentCaption: string = safeParse<string>(object?._generalCommentCaption, '');

        const rootCauseActive: boolean = safeParse<boolean>(object?._rootCauseActive, false);
        const rootCauseSortNumber: number = safeParse<number>(object?._rootCauseSortNumber, 0);
        const rootCauseCaption: string = safeParse<string>(object?._rootCauseCaption, '');

        const correctiveActionActive: boolean = safeParse<boolean>(object?._correctiveActionActive, false);
        const correctiveActionSortNumber: number = safeParse<number>(object?._correctiveActionSortNumber, 0);
        const correctiveActionCaption: string = safeParse<string>(object?._correctiveActionCaption, '');

        const preventiveActionActive: boolean = safeParse<boolean>(object?._preventiveActionActive, false);
        const preventiveActionSortNumber: number = safeParse<number>(object?._preventiveActionSortNumber, 0);
        const preventiveActionCaption: string = safeParse<string>(object?._preventiveActionCaption, '');

        const additionalCommentActive: boolean = safeParse<boolean>(object?._additionalCommentActive, false);
        const additionalCommentSortNumber: number = safeParse<number>(object?._additionalCommentSortNumber, 0);
        const additionalCommentCaption: string = safeParse<string>(object?._additionalCommentCaption, '');

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call
        const customComponents: (ObservationCustomComponentModel | null)[] = object?._customComponents?.map((customComponent: any) => ObservationCustomComponentModel.fromIndexedDB(customComponent)) ?? [];
        
        if (observationId === null || status === null || observationId === '') {
            return null;
        }

        return new ObservationModel(observationId, caption, description, status, ruleSetsActive, ruleSetIds, priorityActive, priorityCaption, priorityOptions, priorityItemEnableMask, priorityVisualOrdering, inspectorCommentActive, inspectorCommentSortNumber, inspectorCommentCaption, generalCommentActive, generalCommentSortNumber, generalCommentCaption, rootCauseActive, rootCauseSortNumber, rootCauseCaption, correctiveActionActive, correctiveActionSortNumber, correctiveActionCaption, preventiveActionActive, preventiveActionSortNumber, preventiveActionCaption, additionalCommentActive, additionalCommentSortNumber, additionalCommentCaption, removeNulls(customComponents));
    }
}

export default ObservationModel;